const MILLISECONDS_DIVIDER = 1000

export const timeSince = (date: string) => {
  const intervals = [
    {
      label: 'year',
      seconds: 31536000
    },
    {
      label: 'month',
      seconds: 2592000
    },
    {
      label: 'day',
      seconds: 86400
    },
    {
      label: 'hour',
      seconds: 3600
    },
    {
      label: 'minute',
      seconds: 60
    },
    {
      label: 'second',
      seconds: 1
    }
  ]

  const timeDiff = Math.floor((Number(new Date()) - Number(new Date(date))) / MILLISECONDS_DIVIDER)
  const interval = intervals.find((interval) => interval.seconds < timeDiff)
  const count = Math.floor(timeDiff / (interval?.seconds ?? 0))

  return {
    key: interval?.label || '',
    value: count
  }
}
